export const EVENTS = {
	JOIN_TYPE_CHANGED: 'JOIN_TYPE_CHANGED',
	USE_MAIN_CHANGED: 'USE_MAIN_CHANGED',
	LINK_DIRECTION_CHANGED: 'LINK_DIRECTION_CHANGED',
	CLICK: 'CLICK',
	MOUSE_OVER: 'MOUSE_OVER'
};